module.exports = __webpack_public_path__ + "static/media/ana.fb6acb30.svg";